import tippy from "tippy.js";

/**
 * Initializes the tippy tooltips on the page.
 */
export default function init() {
  document.querySelectorAll("[data-tippy]").forEach((el) => {
    if (!el.getAttribute("data-tippy")) {
      return;
    }

    const tipAttribute = el.getAttribute("data-tippy") ?? "";

    let contentParts = tipAttribute
      .trim()
      .replaceAll("\n", "<br>")
      .split("<br>");

    // insert a <br> item between each item in contentParts
    for (let i = 0; i < contentParts.length; i++) {
      contentParts.splice(i + 1, 0, "<br>");
      i++;
    }

    const contentDiv = document.createElement("div");
    contentDiv.innerHTML = contentParts
      .join("<br>")
      .replaceAll("<br><br><br>", "<br>");

    // trim any leading or trailing <br> tags
    contentDiv.innerHTML = contentDiv.innerHTML.replace(/^<br>|<br>$/g, "");

    contentDiv.style.padding = "5px";

    tippy(el, {
      content: contentDiv,
      placement: "bottom",
      arrow: true,
      theme: "light",
      interactive: true,
    });
  });
}
